module.exports = __webpack_public_path__ + "static/media/asideLogo.54125c98.svg";